// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3HedF","choiceBoxes":"toolbarselects_choiceBoxes__2Udsb","simpleField":"toolbarselects_simpleField__lLvGt"};